
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-cancel',
  imports: [],
  templateUrl: './cancel-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelIconComponent extends BaseIconComponent {}
